import { render, staticRenderFns } from "./TokenEdit.vue?vue&type=template&id=71af3d2e"
import script from "./TokenEdit.vue?vue&type=script&lang=js"
export * from "./TokenEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports